
import { Component, Prop, Vue } from 'nuxt-property-decorator'

@Component
export default class CardsGridItem extends Vue {
  @Prop({ required: true }) readonly index!: number
  @Prop({ required: false, default: false }) readonly isActive!: boolean
}
